import { type Actions, ActionType } from './auth.actions';
import { initialState, type State } from './auth.state';

export function authReducer(state: State = initialState, action: Actions): State {
    switch (action.type) {
        case ActionType.LOGIN_REQUEST: {
            return {
                ...state,
                isPending: true
            };
        }

        case ActionType.LOGIN_SUCCEEDED: {
            return {
                ...state,
                isAuthenticated: true,
                isPending: false
            };
        }

        case ActionType.LOGIN_FAILED: {
            return {
                ...state,
                isPending: false
            };
        }

        case ActionType.LOGOUT: {
            return {
                ...state,
                isAuthenticated: false,
                token: null,
                isPending: false,
                isConnectedAs: false
            };
        }

        case ActionType.UPDATE_OAUTH_TOKEN: {
            return {
                ...state,
                token: action.payload.token,
                sessionId: action.payload.newSessionId ? action.payload.newSessionId : state.sessionId
            };
        }

        case ActionType.SET_IS_CONNECTED_AS: {
            return {
                ...state,
                isConnectedAs: action.payload
            };
        }

        default:
            return state;
    }
}
